const LOCALE_GERMAN = 'de-DE';

// DKV Mobility only has a German-language page for this product.
export const dkvMobilityLink = () =>
  'https://www.dkv-mobility.com/de/de/fuelling/fuel-card/all-cards/dkv-card';

export const utaEdenredLink = (locale: string) =>
  locale === LOCALE_GERMAN
    ? 'https://web.uta.com/de/uta-edenred-man-simple-pay'
    : 'https://web.uta.com/en/uta-edenred-man-simple-pay';

export const driverAppLink = (locale: string) =>
  locale === LOCALE_GERMAN
    ? 'https://www.man.eu/de/de/services-zubehoer/fahrerassistenz-training/man-driver-app.html'
    : 'https://www.man.eu/uk/en/services-accessories/driver-assistance-training/man-driver-app.html';

export const chargeAndGoLink = (locale: string) =>
  `https://rio.cloud/${locale.split('-')[0]}/marketplace/produkt/man-charge-and-go`;

export const openInNewTab = (url: string) =>
  window.open(url, '_blank', 'noopener');
